import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { hsaMerchantClassificationProjection } from "./hsa-merchant-classification";

/** Proceeds (then classifies the business lines) or declines a restricted-category flag. */
export const resolveHsaRestrictedReview = {
  name: "resolveHsaRestrictedReview" as const,
  input: z.object({
    teamId: zExt.objectId(),
    decision: z.enum(["proceeded", "declined"]),
    note: z.string().optional(),
  }),
  output: z.object({
    outcome: z.enum([
      "declined",
      "classified",
      "mcc_review_pending",
      "paused_for_review",
    ]),
    classification: hsaMerchantClassificationProjection,
  }),
};
